<template>
  <label
    class="btn btn-secondary has-checked:bg-primary has-checked:border-primary has-checked:text-white"
    :class="`btn-${size}`"
    @click.prevent="handleLabelClick"
  >
    <input
      type="radio"
      class="hidden"
      :checked="isChecked"
      :value="value"
      :name="name"
      @click.prevent
    />
    <slot />
  </label>
</template>

<script setup>
import { computed } from 'vue';

const props = defineProps({
  name: {
    type: String,
    required: true,
  },
  modelValue: {
    type: [String, Boolean],
  },
  value: {
    type: [String, Boolean],
  },
  size: {
    type: String,
    default: 'md',
    validator: (value) => ['xs', 'sm', 'md', 'lg'].includes(value),
  },
});

const emit = defineEmits(['update:modelValue']);

const isChecked = computed(() => {
  return props.modelValue === props.value;
});

const handleLabelClick = () => {
  if (props.modelValue !== props.value) {
    emit('update:modelValue', props.value);
  }
};
</script>
